/** Process-scope RCM column ids used for show/hide (gear menu). */
export const RCM_ASSERTION_COLUMN_IDS = [
  'completeness',
  'existenceOccurrence',
  'accuracy',
  'valuation',
  'rightsObligations',
];

export const RCM_TABLE_COLUMNS = [
  { id: 'srNo', label: 'Sr. No.', hideable: false },
  { id: 'classification', label: 'Classification', hideable: true },
  { id: 'soxCycle', label: 'SOX Cycle', hideable: true },
  { id: 'subProcess', label: 'Sub-process', hideable: true },
  { id: 'riskId', label: 'Risk ID', hideable: true },
  { id: 'clientRiskId', label: 'Client Risk ID', hideable: true },
  { id: 'riskDescription', label: 'Risk Description', hideable: true },
  { id: 'controlId', label: 'Control ID', hideable: true },
  { id: 'controlObjective', label: 'Control Objective Description', hideable: true },
  { id: 'controlDescription', label: 'Control Description', hideable: true },
  { id: 'completeness', label: 'Completeness (C)', hideable: true, assertion: true },
  { id: 'existenceOccurrence', label: 'Existence & Occurrence (E&O)', hideable: true, assertion: true },
  { id: 'accuracy', label: 'Accuracy (A)', hideable: true, assertion: true },
  { id: 'valuation', label: 'Valuation (V)', hideable: true, assertion: true },
  { id: 'rightsObligations', label: 'Rights & Obligations (R&O)', hideable: true, assertion: true },
  { id: 'what', label: 'Control Title', hideable: true },
  { id: 'who', label: 'Control Owner', hideable: true },
  { id: 'keyReports', label: 'Key Reports', hideable: true },
  { id: 'when', label: 'Frequency', hideable: true },
  { id: 'controlType', label: 'Control Type', hideable: true },
  { id: 'keyNonKey', label: 'Key / Non Key', hideable: true },
  { id: 'riskCategory', label: 'Risk Category', hideable: true },
];

export function createDefaultRcmColumnVisibility() {
  return Object.fromEntries(RCM_TABLE_COLUMNS.map((column) => [column.id, true]));
}

export function isRcmColumnVisible(columnVisibility, columnId) {
  if (!columnId) return false;
  return columnVisibility?.[columnId] !== false;
}

export function getVisibleRcmColumnCount(columnVisibility) {
  return RCM_TABLE_COLUMNS.filter((column) => isRcmColumnVisible(columnVisibility, column.id)).length;
}

export function getHideableRcmColumns() {
  return RCM_TABLE_COLUMNS.filter((column) => column.hideable !== false);
}

export function getDefaultRcmColumnOrder() {
  return RCM_TABLE_COLUMNS.map((column) => column.id);
}

/** Merge a hideable-only reorder into the full column order (keeps non-hideable pins). */
export function mergeRcmHideableOrder(fullOrder, orderedHideableIds) {
  const base = Array.isArray(fullOrder) && fullOrder.length > 0
    ? [...fullOrder]
    : getDefaultRcmColumnOrder();
  const hideableSet = new Set(orderedHideableIds);
  let cursor = 0;
  const next = base.map((id) => {
    if (!hideableSet.has(id)) return id;
    const replacement = orderedHideableIds[cursor];
    cursor += 1;
    return replacement ?? id;
  });
  for (const id of orderedHideableIds) {
    if (!next.includes(id)) next.push(id);
  }
  // Keep any newly added canonical columns that were missing.
  for (const id of getDefaultRcmColumnOrder()) {
    if (!next.includes(id)) next.push(id);
  }
  return next;
}

export function getOrderedVisibleRcmColumnIds(columnOrder, columnVisibility) {
  const order = Array.isArray(columnOrder) && columnOrder.length > 0
    ? columnOrder
    : getDefaultRcmColumnOrder();
  const known = new Set(RCM_TABLE_COLUMNS.map((c) => c.id));
  return order.filter((id) => known.has(id) && isRcmColumnVisible(columnVisibility, id));
}

export function isRcmAssertionColumnId(columnId) {
  return RCM_ASSERTION_COLUMN_IDS.includes(columnId);
}
